import { render, staticRenderFns } from "./LimpiarrejasPantalla.vue?vue&type=template&id=d9277710&scoped=true"
import script from "./LimpiarrejasPantalla.vue?vue&type=script&lang=js"
export * from "./LimpiarrejasPantalla.vue?vue&type=script&lang=js"
import style0 from "./LimpiarrejasPantalla.vue?vue&type=style&index=0&id=d9277710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9277710",
  null
  
)

export default component.exports